import React from 'react'
import { Row, Col, Collapse, Container } from 'reactstrap'
import { List, ListItem, Label } from './styled'

export default ({
  label = 'Items',
  items = [],
  removeHandler,
  noResultsText
}) => {
  const [isOpen, setIsOpen] = React.useState({})

  const toggle = (index) => {
    setIsOpen({ ...isOpen, [index]: !isOpen[index] })
  }

  const handleRemove = (index) => (e) => {
    e.stopPropagation()
    removeHandler(index)
  }

  return items.length
    ? (
      <div>
        <Label>{label}</Label>
        <Row>
          <Col xs='12'>
            <List>
              {
                items.map(
                  ({ data, headerComponent, detailComponent }, index) => (
                    <ListItem
                      key={index}
                    >
                      <Container>
                        <Row>
                          <Col xs='12' className='p-0'>
                            {React.cloneElement(headerComponent, { data, isOpen: isOpen[index], removeHandler: handleRemove(index), toggle: () => toggle(index) })}
                          </Col>
                        </Row>
                        {detailComponent &&
                          <Collapse isOpen={isOpen[index] || false}>
                            <Row>
                              <Col xs='12'>
                                {React.cloneElement(detailComponent, { data, isOpen: isOpen[index] })}
                              </Col>
                            </Row>
                          </Collapse>}
                      </Container>
                    </ListItem>
                  )
                )
              }
            </List>
          </Col>
        </Row>
      </div>)
    : <Label>{noResultsText}</Label>
}
